import { Language } from "@faire/web-api--source/indigofair/languages/Language";

import { DataByLocale } from "@faire/retailer/lib/localization";

import { TOSCountryType, TOSType } from "./consts";
import { chooseArticleId } from "./utils";

export const getFairePayTOSArticleData = (): DataByLocale => ({
  linkOrId: chooseArticleId(TOSType.FAIRE_PAY, TOSCountryType.USA),
  locale: Language.ENG,
});
